const en: Record<string, string> = {
  loading: "Loading...",
  loadingDashboard: "Loading dashboard...",
  loadingDates: "Loading dates...",
  loadingSlots: "Loading slots...",
  redirecting: "Redirecting...",
  authenticating: "Authenticating...",
  saving: "Saving...",
  savingEllipsis: "Saving...",
  pleaseWait: "Please wait...",
  pleaseWaitSignIn: "Please wait while we complete your sign-in.",
  failed: "Failed",
  failedToLoadSchedule: "Failed to load schedule",
  failedToLoadSettings: "Failed to load settings",
  sessionExpired: "Session expired",
  apiError: "API error: {status}",
  rescheduleFailed: "Reschedule failed",
  authFailed: "Authentication failed",
  authFailedTitle: "Authentication Failed",
  missingAuthCode: "Missing authorization code or state.",
  invalidState: "Invalid state parameter. Please try logging in again.",
  loginInitFailed: "Failed to initialize login. Please try again.",
  popupBlocked: "Popup blocked. Please allow popups for this site and try again.",
  loginWindowClosed: "Login window was closed.",
  accessDenied: "Access denied. Your account does not have admin privileges. Please contact your administrator.",
  accountDeactivated: "This account has been deactivated. Please contact your administrator to restore it.",
  yourAccount: "Your account",
  failedOpenLogin: "Failed to open login window.",
  bookingRescheduled: "Booking rescheduled successfully",
  companySettingsSaved: "Company settings saved",
  bookingPoliciesSaved: "Booking policies saved",
  scheduleSaved: "Schedule saved",
  lineConfigSaved: "LINE configuration saved",
  staffCreated: "Staff member added",
  staffUpdated: "Staff member updated",
  staffActivated: "Staff member activated",
  staffDeactivated: "Staff member deactivated",
  notifySettingSaved: "Notification setting saved",
  orderSaved: "Order saved",
  serviceCreated: "Service added",
  serviceUpdated: "Service updated",
  serviceActivated: "Service activated",
  serviceDeactivated: "Service deactivated",
  unavailabilityAdded: "Unavailability block added",
  unavailabilityRemoved: "Unavailability block removed",
  bookingCancelled: "Booking cancelled",
  bookingCompleted: "Booking marked complete",
  deactivateServiceConfirm: "Deactivate this service?",
  deactivateStaffConfirm: "Deactivate this staff member?",
  markCompleted: "Mark completed",
  completeBookingConfirm: "Mark this consultation as completed?",
  cancelBookingConfirm: "Cancel this booking?",
  removeBlockConfirm: "Remove this unavailability block?",
  yes: "Yes",
  no: "No",
  dashboard: "Dashboard",
  services: "Services",
  staff: "Staff",
  bookings: "Bookings",
  calendar: "Calendar",
  reschedules: "Reschedules",
  logs: "Logs",
  users: "Users",
  settings: "Settings",
  logout: "Logout",
  viewSite: "View site",
  language: "Language",
  bookingAdmin: "Admin",
  adminDesc: "Admin dashboard for booking management",
  addService: "Add Service",
  addStaff: "Add Staff",
  saveCompanyInfo: "Save Company Info",
  companyLogo: "Company Logo",
  companyLogoHelp: "Shown to customers on their booking pages. PNG, JPEG or WebP, up to 5 MB.",
  uploadLogo: "Upload Logo",
  replaceLogo: "Replace Logo",
  removeLogo: "Remove Logo",
  logoSaved: "Logo updated",
  logoRemoved: "Logo removed",
  saveBookingPolicies: "Save Booking Policies",
  saveLineConfig: "Save LINE Config",
  saveSchedule: "Save Schedule",
  createRichMenu: "Create Rich Menu",
  configureLine: "Configure LINE",
  signIn: "Sign in with auth service",
  allStatuses: "All Statuses",
  loginTitle: "Admin",
  loginSubtitle: "Sign in to your dashboard",
  todayBookings: "Today's Bookings",
  totalBookings: "Total Bookings",
  upcoming: "Upcoming",
  bookingsCount: "{n} bookings",
  activeUsers: "Active Users",
  pending: "Pending",
  totalRevenue: "Total Revenue",
  noBookingsToday: "No bookings today",
  todayReschedules: "Today's Reschedules",
  noReschedulesToday: "No reschedules today",
  noBookingsFound: "No bookings found",
  noServicesYet: "No services yet",
  noStaffYet: "No staff yet",
  noUsersFound: "No users found",
  noReschedulesFound: "No reschedules found",
  noBlocks: "No blocks",
  noAvailableSlots: "No available slots for this date.",
  clickDateToView: "Click a date to view bookings",
  noBookingsOnDate: "No bookings on {date}",
  selectDate: "Select a date",
  bookingCalendar: "Booking Calendar",
  rescheduleBooking: "Reschedule Booking",
  rescheduleBookingTitle: "Reschedule",
  addServiceTitle: "Add Service",
  editServiceTitle: "Edit Service",
  serviceCode: "Service Code",
  serviceCodeHint: "Used in booking URLs. Lowercase, no spaces (e.g. posture, shoulder)",
  addStaffTitle: "Add Staff",
  editStaffTitle: "Edit Staff",
  weeklySchedule: "Weekly Schedule",
  addBreak: "Add break",
  scheduleWeekSummary: "{days} working days · {hours} a week",
  dayOff: "Day off",
  workingHours: "Hours",
  breakLabel: "Break (not bookable)",
  removeBreak: "Remove break",
  scheduleEndAfterStart: "End time must be after start time",
  newBlock: "New block",
  addBlock: "Add block",
  setHours: "Set hours",
  blockSummary: "{count} upcoming",
  upcomingTab: "Upcoming",
  pastTab: "Past",
  noUpcomingBlocks: "No upcoming blocks",
  noUpcomingBlocksHint: "Use the form above to block out a whole day or a few hours.",
  removeBlockConfirmDetail: "Remove the block on {when}?",
  scheduleBreakInside: "The break must start and end inside the working hours",
  bookable: "Bookable",
  copyToWorkingDays: "Copy these hours to all working days",
  breakTime: "Break (weekly schedule)",
  unavailabilityBlocks: "Unavailability Blocks",
  pastBlocks: "Past blocks",
  noPastBlocks: "No past blocks",
  availableTimes: "Available Times",
  companyInformation: "Company Information",
  bookingPolicies: "Booking Policies",
  moreActions: "More actions",
  lineIntegration: "LINE Integration",
  richMenu: "Rich Menu",
  companyName: "Company Name",
  description: "Description",
  phone: "Phone",
  email: "Email",
  address: "Address",
  timezone: "Timezone",
  type: "Type:",
  durationMinutes: "Duration (minutes)",
  priceYen: "Price (¥)",
  bio: "Bio",
  slotInterval: "Slot Interval (minutes)",
  bufferTime: "Buffer Time (minutes)",
  cancellationPolicy: "Cancellation Policy (hours before appointment)",
  reminder24h: "24h Reminder",
  reminder1h: "1h Reminder",
  showSlotStaffCount: "Show staff count on time slots",
  showSlotStaffCountHelp: "Shows how many staff are free on each time slot in the booking flow, e.g. '2 open'",
  showServiceDuration: "Show service duration",
  showServiceDurationHelp: "Shows each service's duration (e.g. 60 min) on the booking site and in the LINE menu. Turning it off shows the price alone; slot generation is unaffected",
  pointsSection: "Points",
  pointsStatusOn: "On ({rate}% back)",
  pointsStatusOff: "Off",
  pointsManagedInAuth: "Points are now one balance shared by every app (clinic, gym and the rest), and are set in the auth service's admin, under OAuth Clients.",
  openingSpecialSection: "Opening Special",
  openingSpecialEnabled: "Apply the opening special",
  openingSpecialHelp: "When on, every menu item sells at the price below, and the booking site shows a banner with the original prices struck through. Free items and items already cheaper than this price are unchanged. Bookings keep the price they were made at, so ending the special does not change past bookings or their points",
  openingSpecialPrice: "Special price (¥)",
  openingSpecialPriceInvalid: "Enter a whole number of ¥1 or more",
  openingSpecialSave: "Save Opening Special",
  openingSpecialSaved: "Opening special saved",
  thPoints: "Points",
  pointsHistory: "Points history",
  pointsBalance: "Balance",
  pointsEmpty: "No points yet.",
  selectableLengths: "Customer chooses the length",
  selectableLengthsHint: "When on, the customer picks from the lengths below instead of a single fixed duration",
  bookingDurationOptions: "Selectable lengths (min)",
  bookingDurationOptionsHelp: "Comma-separated lengths a customer can choose when booking this service (e.g. 30, 60, 90)",
  bookingDuration: "Duration",
  lineChannelId: "Messaging API Channel ID",
  lineChannelSecret: "Messaging API Channel Secret",
  lineChannelAccessToken: "Messaging API Channel Access Token (Long-lived)",
  lineLoginChannelId: "LINE Login Channel ID",
  liffAppId: "LIFF App ID",
  liffEndpointUrl: "LIFF Endpoint URL",
  liffEndpointUrlHint: "Paste this into the LINE Developers console under the LINE Login channel \u2192 LIFF \u2192 this app \u2192 Endpoint URL. It must be the customer app above \u2014 not the admin site you are reading this on, which has its own login screen and would leave customers staring at it.",
  slotIntervalHelp: "Time between each bookable slot (e.g. 30 = 9:00, 9:30, 10:00...)",
  bufferTimeHelp: "Gap between bookings for cleanup/prep (blocks next slot after buffer)",
  lineConfigDesc: "Configure your LINE Official Account channel to enable messaging, rich menus, and LIFF integration.",
  richMenuDesc: "Create a default rich menu for your LINE Official Account. Requires all LINE channel fields to be configured.",
  lineDiagnose: "Diagnose",
  lineDiagnosing: "Checking...",
  lineDiagnoseDesc: "Check which LINE Official Account this channel access token controls, and whether the webhook is set up correctly.",
  lineDiagnoseOk: "No problems found.",
  lineConnectedOa: "Connected LINE Official Account",
  chat: "Chat",
  emailUser: "Email",
  copy: "Copy",
  copied: "Copied",
  notFound: "Customer not found",
  lineChatMode: "Response mode",
  lineChatModeBot: "Bot",
  lineChatModeChat: "Chat (LINE auto-replies)",
  lineTokenChannel: "Token's channel",
  lineConfiguredChannel: "Configured Channel ID",
  lineTokenExpiry: "Token expires in",
  lineTokenExpiryDays: "{days} days",
  lineWebhookUrl: "Webhook URL",
  lineWebhookUrlHint: "Paste this into the LINE Developers console under Messaging API → Webhook URL, then turn on \"Use webhook\".",
  lineWebhookExpected: "Expected",
  lineWebhookUnset: "Not set",
  lineWebhookActive: "Webhook enabled",
  lineWebhookTest: "Webhook test",
  lineWebhookTestOk: "OK",
  channelConfigured: "Channel configured",
  channelNotConfigured: "Not configured",
  liffIdSet: "LIFF ID set",
  liffIdNotSet: "LIFF ID not set",
  searchNamePhone: "Search by name or phone...",
  placeholderStart: "Start",
  placeholderEnd: "End",
  placeholderLineChannelId: "e.g. 1234567890 (Messaging API channel)",
  placeholderLineLoginChannelId: "e.g. 1234567890 (LINE Login channel for LIFF auth)",
  placeholderSecretSet: "Currently set — leave blank to keep",
  placeholderSecretUnset: "Channel secret from LINE Developers Console",
  placeholderAccessTokenSet: "Currently set — leave blank to keep",
  placeholderAccessTokenUnset: "Long-lived channel access token",
  placeholderLiffId: "e.g. 1657890123-aBcDeFgH",
  thWhen: "When",
  thSource: "Source",
  thDate: "Date",
  thTime: "Time",
  thNote: "Note",
  thUser: "User",
  thService: "Service",
  thStaff: "Staff",
  thStatus: "Status",
  thActions: "Actions",
  thName: "Name",
  thDuration: "Duration",
  thPrice: "Price",
  thCategory: "Category",
  thMethod: "Method",
  meetingMethodPHONE: "By phone",
  meetingMethodEMAIL: "By email",
  meetingMethodIN_PERSON: "In person",
  thJoined: "Joined",
  thRescheduledBy: "Rescheduled By",
  thOriginal: "Original",
  thNew: "New",
  thRescheduledAt: "Rescheduled At",
  active: "Active",
  inactive: "Inactive",
  cancelled: "Cancelled",
  noShow: "No Show",
  confirmed: "Confirmed",
  completed: "Completed",
  allDay: "All day",
  actorUser: "USER",
  prev: "Prev",
  next: "Next",
  back: "Back",
  tryAgain: "Try Again",
  add: "Add",
  edit: "Edit",
  cancel: "Cancel",
  close: "Close",
  remove: "Remove",
  search: "Search",
  create: "Create",
  update: "Update",
  activate: "Activate",
  deactivate: "Deactivate",
  reschedule: "Reschedule",
  pagerRange: "{shown} of {total}",
  bookingCount: "{count} booking(s)",
  userCount: "{count} user(s)",
  sun: "Sun",
  mon: "Mon",
  tue: "Tue",
  wed: "Wed",
  thu: "Thu",
  fri: "Fri",
  sat: "Sat",
  min: "min",
  addBooking: "Add Booking",
  addBookingTitle: "New Booking",
  addUser: "Add User",
  addUserTitle: "New User",
  userCreated: "User created",
  userCreateFailed: "Failed to create user",
  userEmailRequired: "Email is required",
  userNameRequired: "Name is required",
  userPhoneInvalid: "Enter a phone number starting with 0 (10–11 digits, e.g. 09012345678)",
  phonePlaceholder: "e.g. 09012345678",
  userEmailInvalid: "Enter a valid email address",
  userEmailExists: "A user with this email already exists",
  userActivated: "User activated",
  userDeactivated: "User deactivated",
  userStatusUpdateFailed: "Failed to update user status",
  editUserTitle: "Edit User",
  userUpdated: "User updated",
  userUpdateFailed: "Failed to update user",
  resetPassword: "Reset Password",
  resetPasswordTitle: "Reset Password",
  newPassword: "New password",
  confirmPassword: "Confirm new password",
  passwordMismatch: "Passwords do not match",
  passwordTooShort: "Password must be at least 8 characters",
  passwordTooLong: "Password must be 72 characters or fewer",
  passwordResetDone: "Password reset",
  passwordResetFailed: "Failed to reset password",
  userNoLoginAccount: "This customer has no login account",
  dashboardAccount: "Dashboard account",
  dashboardAccountLocked: "Dashboard accounts cannot be modified from the customers page",
  deactivateUserConfirm: "Deactivate this user? They will not be able to log in.",
  selectService: "Select a service",
  selectStaff: "Select staff",
  selectUser: "Select a user",
  searchUser: "Search user...",
  newUser: "New User",
  userName: "User Name",
  userPhone: "User Phone",
  bookingNotes: "Notes",
  viewFullNote: "View",
  bookingCreated: "Booking created",
  bookingCreateFailed: "Failed to create booking",
  selectTime: "Select a time",
  eventLogs: "Event Logs",
  allActions: "All Actions",
  allTypes: "All Types",
  allActors: "All Actors",
  clear: "Clear",
  eventCount: "{count} events",
  noLogsFound: "No logs found",
  thAction: "Action",
  thActor: "Actor",
  thTarget: "Target",
  thDetails: "Details",
  groupAuth: "Auth",
  groupBookings: "Bookings",
  groupServices: "Services",
  groupStaff: "Staff",
  groupUsers: "Users",
  groupSettings: "Settings",
  groupMessages: "Messages",
  groupMail: "Mail",
  targetAuth: "auth",
  targetBooking: "booking",
  targetService: "service",
  targetStaff: "staff",
  targetUser: "user",
  targetCompany: "company",
  targetConversation: "conversation",
  targetMailThread: "mail thread",
  targetReschedule: "reschedule",
  actorAdmin: "ADMIN",
  actorSystem: "SYSTEM",
  actionAuthLoginSuccess: "Login Success",
  actionAuthLoginFailed: "Login Failed",
  actionAuthAccessDenied: "Access Denied",
  actionBookingCreated: "Booking Created",
  actionBookingCancelled: "Booking Cancelled",
  actionBookingRescheduled: "Booking Rescheduled",
  actionBookingConfirmed: "Booking Confirmed",
  actionBookingCompleted: "Booking Completed",
  actionBookingNoShow: "No Show",
  actionBookingStatusUpdated: "Status Updated",
  actionServiceCreated: "Service Created",
  actionServiceUpdated: "Service Updated",
  actionServiceDeactivated: "Service Deactivated",
  actionServiceActivated: "Service Activated",
  actionStaffCreated: "Staff Created",
  actionStaffUpdated: "Staff Updated",
  actionStaffDeactivated: "Staff Deactivated",
  actionStaffActivated: "Staff Activated",
  actionStaffReordered: "Staff Reordered",
  actionScheduleUpdated: "Schedule Updated",
  actionUnavailabilityAdded: "Unavailability Added",
  actionUnavailabilityRemoved: "Unavailability Removed",
  actionUserCreated: "User Created",
  actionUserRegistered: "User Registered",
  actionUserUpdated: "User Updated",
  actionUserActivated: "User Activated",
  actionUserDeactivated: "User Deactivated",
  actionUserPasswordReset: "Password Reset",
  actionAuthSyncFailed: "Auth Sync Failed",
  actionSettingsUpdated: "Settings Updated",
  actionLineFollow: "LINE Follow",
  actionLineUnfollow: "LINE Unfollow",
  actionLineMessageReceived: "LINE Message Received",
  actionLineAutoReplySent: "LINE Auto-Reply",
  actionLineMessageSent: "LINE Reply Sent",
  actionLineQuotaExceeded: "LINE Quota Exceeded",
  actionConversationDeleted: "Conversation Deleted",
  actionMailMessageSent: "Mail Sent",
  actionMailThreadDeleted: "Mail Thread Deleted",
  actionBookingDeleted: "Booking Deleted",
  actionRescheduleDeleted: "Reschedule Deleted",
  actionUserDeleted: "User Deleted",
  logAuthLoginSuccess: "{name} ({email}) logged in via {source}",
  logAuthLoginFailed: "Login failed via {source}: {error}",
  logAuthAccessDenied: "Access denied for {email} — {reason}{role}",
  unverifiedSuffix: "(unverified)",
  logBookingCreated: "{actor} created a booking for {user} — {service} with {staff} at {time}",
  logBookingCancelled: "{actor} cancelled {user}'s booking — {service} with {staff}",
  logBookingRescheduled: "{actor} rescheduled {user}'s booking — {service} with {staff}: {oldDate} {oldTime} → {newDate} {newTime}",
  logBookingConfirmed: "{actor} confirmed {user}'s booking — {service} with {staff} at {time}",
  logBookingCompleted: "{actor} completed {user}'s booking — {service} with {staff} at {time}",
  logBookingNoShow: "{actor} marked {user} as no-show — {service} with {staff} at {time}",
  logBookingStatusUpdated: "{actor} updated {user}'s booking status: {oldStatus} → {newStatus}",
  logServiceCreated: "{actor} created service {name} ({duration}min, ¥{price})",
  logServiceUpdated: "{actor} updated service {name}",
  logServiceDeactivated: "{actor} deactivated service {name}",
  logServiceActivated: "{actor} activated service {name}",
  logStaffCreated: "{actor} added staff member {name}",
  logStaffUpdated: "{actor} updated staff member {name}",
  logStaffDeactivated: "{actor} deactivated staff member {name}",
  logStaffActivated: "{actor} activated staff member {name}",
  logStaffReordered: "{actor} reordered staff members",
  logScheduleUpdated: "{actor} updated schedule: {details}",
  logUnavailabilityAdded: "{actor} added unavailability: {details}",
  logUnavailabilityRemoved: "{actor} removed unavailability: {details}",
  logUserCreated: "{actor} created user {name} ({email})",
  logUserRegistered: "{name} registered",
  logUserUpdated: "{actor} updated user {name}: {fields}",
  logUserActivated: "{actor} activated user {name}",
  logUserDeactivated: "{actor} deactivated user {name}",
  logUserPasswordReset: "{actor} reset the password for user {name}",
  logAuthSyncFailed: "Syncing {operation} to the auth service failed: {error}",
  logSettingsUpdated: "{actor} updated settings: {fields}",
  logLineFollow: "{actor} added us on LINE",
  logLineUnfollow: "{actor} unfollowed us on LINE",
  logLineMessageReceived: "{actor} sent a LINE message",
  logLineAutoReplySent: "{actor} sent an auto-reply",
  logLineMessageSent: "{actor} replied via LINE",
  logLineQuotaExceeded: "{actor}: LINE quota exceeded — reminder not sent",
  logConversationDeleted: "{actor} deleted a conversation",
  logMailMessageSent: "{actor} sent a mail message",
  logMailThreadDeleted: "{actor} deleted a mail thread",
  logBookingDeleted: "{actor} deleted a booking — {user} · {service} · {staff}",
  logRescheduleDeleted: "{actor} deleted a reschedule request — {user} · {service} · {staff}",
  logUserDeleted: "{actor} deleted customer {name}",
  logMetaAuth: "Auth",
  logMetaBooking: "Booking #{id}",
  logMetaService: "Service #{id}",
  logMetaStaff: "Staff #{id}",
  logMetaUser: "User #{id}",
  logMetaCompany: "Company",
  logMetaConversation: "Conversation #{id}",
  logMetaMailThread: "Mail thread #{id}",
  logMetaReschedule: "Reschedule #{id}",

  messages: "LINE Messages",
  messagesTitle: "LINE Messages",
  messagesEmpty: "No messages yet — share your LINE link with customers!",
  inbox: "Inbox",
  unread: "unread",
  replyPlaceholder: "Type a reply...",
  send: "Send",
  sending: "Sending...",
  noConversationSelected: "Select a conversation",
  unknownCustomer: "Unknown customer",
  customerInfo: "Customer Info",
  recentBookings: "Recent Bookings",
  statusOpen: "Open",
  statusPending: "Pending",
  statusClosed: "Closed",
  customerUnreachable: "This customer cannot receive LINE messages (blocked or unfriended)",
  lineQuotaExceeded: "LINE message quota reached. Please retry shortly.",
  lineQuotaRemaining: "LINE messages left: {remaining} / {total}",
  lineQuotaUnlimited: "LINE quota: Unlimited",
  linePlanLimited: "Limited",
  linePlanUnlimited: "Unlimited",
  lineQuotaInline: "{plan} · {used}/{total} ({percent}%)",
  lineQuotaInlineUnlimited: "{plan} · {used} this month",
  lineNotConfigured: "LINE not configured",
  lineQuotaTitle: "LINE message quota",
  messageSent: "Sent",
  messageFailed: "Failed to send. Please try again",
  searchPlaceholder: "Search by name or message...",
  filterAll: "All",
  filterOpen: "Open",
  filterPending: "Pending",
  filterClosed: "Closed",
  filterUnassigned: "Unassigned",
  filterAssignedMe: "Assigned to me",
  filterByStatus: "Filter",
  noBookings: "No bookings",
  openInMessages: "Open in Messages",
  viewFullDetails: "View full details",
  service: "Service",
  colDate: "Date",
  colTime: "Time",
  bookingHistory: "Booking History",
  noMessagesYet: "No conversation yet",
  activityLog: "Activity Log",
  noActivity: "No activity",
  assignTo: "Assign to",
  retry: "Retry",
  stickerAlt: "Sticker",
  memberSince: "Joined",
  lineId: "LINE ID",
  notProvided: "—",

  // --- Shared features (webmail, hard-delete, staff notify/reorder, one-time) ---
  bookingDeleted: "Booking deleted",
  conversationDeleted: "Conversation deleted",
  crossOff: "Cross off",
  crossOffTitle: "Block this time",
  crossOffUntil: "Until",
  crossOffReason: "Note (optional)",
  crossOffReasonPlaceholder: "e.g. break",
  existingCustomer: "Existing customer",
  noteOnly: "Note only",
  noteOnlyHint: "Books the slot with a note and no customer. It appears in the bookings list as a confirmed booking.",
  noteRequired: "A note is required when there is no customer",
  crossOffHint: "Click a free slot to cross it off; click a crossed-off slot to restore it.",
  crossedOff: "Crossed off",
  restoreSlotConfirm: "Restore this slot? It becomes bookable again and the note on it is deleted.",
  pastDateCannotChange: "Past dates can't be changed.",
  customerDeleted: "Customer deleted",
  delete: "Delete",
  deleteBookingConfirm: "Permanently delete this booking? This frees the slot and cannot be undone.",
  deleteConversationConfirm: "Permanently delete this conversation and all its messages? This cannot be undone.",
  deleteCustomerConfirm: "Permanently delete this customer? Their bookings and conversations will also be deleted. This cannot be undone.",
  deleteMailConfirm: "Permanently delete this mail thread? This cannot be undone.",
  deleteRescheduleConfirm: "Delete this reschedule record? The booking's date/time is unchanged. This cannot be undone.",
  dragToReorderHint: "Drag to reorder",
  emailHint: "Email address for booking notifications",
  emailNotify: "Email Notify",
  lineIdHint: "LINE user ID for booking notifications",
  staffLinkUser: "Link customer record",
  staffUnlink: "Unlink",
  staffLinkUserHint: "Search a customer to fill the LINE ID and email fields from their record.",
  lineNotify: "LINE Notify",
  mail: "Email",
  mailAllInboxes: "All",
  mailDeleted: "Mail thread deleted",
  mailFilter_all: "All",
  mailFilter_closed: "Closed",
  mailFilter_open: "Open",
  mailFilter_pending: "Pending",
  mailLinkedCustomer: "Customer",
  mailLoadFailed: "Failed to load email",
  mailNoLinkedCustomer: "No linked customer",
  mailNoMailboxes: "No mailboxes configured. Add one in Settings → Email.",
  mailNoSubject: "(no subject)",
  mailNoThreadSelected: "Select an email to read",
  mailNoThreads: "No emails",
  mailSearchPlaceholder: "Search email…",
  mailSendFailed: "Failed to send reply",
  dateRequired: "Pick a date first",
  assignFailed: "Failed to change the assignee",
  statusUpdateFailed: "Failed to update the status",
  mailStatusUpdateFailed: "Failed to update the thread status",
  mailSent: "Reply sent",
  mailSettings: "Email",
  mailStaff: "Staff",
  mailStatusLabel: "Status",
  mailStatus_closed: "Closed",
  mailStatus_open: "Open",
  mailStatus_pending: "Pending",
  mailTitle: "Email",
  mailCompose: "Compose",
  mailComposeTitle: "New email",
  mailFrom: "From",
  mailTo: "To",
  mailSubject: "Subject",
  mailBody: "Message",
  mailComposeSent: "Email sent",
  goToMailPage: "Go to email page",
  mailUnknownCustomer: "Unknown customer",
  mailboxActive: "Active (poll this inbox)",
  mailboxAdd: "Add mailbox",
  mailboxDeleteConfirm: "Delete mailbox {email}? Its stored threads will be removed.",
  mailboxEdit: "Edit mailbox",
  mailboxEmail: "Email address",
  mailboxEncNone: "None",
  mailboxEncryption: "Encryption",
  mailboxError: "poll error",
  mailboxFromName: "Sender name",
  mailboxImapHost: "IMAP host",
  mailboxImapPassword: "IMAP password",
  mailboxImapPort: "IMAP port",
  mailboxImapUser: "IMAP username",
  mailboxInactive: "inactive",
  mailboxLabel: "Label",
  mailboxPasswordKeep: "Leave blank to keep current",
  mailboxSaved: "Mailbox saved",
  mailboxesDesc: "Inboxes polled over IMAP and shown in the Email inbox. Add one or more.",
  mailboxesEmpty: "No mailboxes yet.",
  mailboxesTitle: "Mailboxes",
  noBookingsForStaff: "No bookings for this staff member on this day.",
  notifyFromDefault: "Default (service default sender)",
  notifyFromDesc: "Booking notification emails are sent from this address, and customer replies return to its inbox.",
  notifyFromSaved: "Notification sender saved",
  notifyFromTitle: "Send notifications from",
  oneTimeOnly: "One-time only",
  oneTimeOnlyHint: "Each customer can book this service only once",
  profilePhoto: "Profile Photo",
  removePhoto: "Remove Photo",
  reorderFailed: "Could not save the new order",
  rescheduleDeleted: "Reschedule record deleted",
  restore: "Restore",
  save: "Save",
  selectStaffToManage: "Select a staff member to manage slots.",
  staffNotWorking: "This staff member is not working on this day.",
  thReorder: "Order",

  // --- Gym memberships ---
  plans: "Plans",
  // The staff edit modal's plan checkboxes (StaffLinkSection). Defined only here:
  // clinic and fudousan register no section, so the keys are unreachable there
  // and t() would fall through to the key name anyway.
  staffLinks: "Assigned Services",
  staffLinksHint: "This staff member is only offered for bookings of the selected services.",
  staffLinksNone: "No services selected — this staff member cannot be booked.",
  staffLinksSaveFailed: "Staff saved, but the service assignment could not be saved.",
  addPlan: "Add Plan",
  addPlanTitle: "Add Plan",
  editPlanTitle: "Edit Plan",
  noPlansYet: "No plans yet",
  deactivatePlanConfirm:
    "Deactivate this plan? It stays linked to existing memberships but is hidden from the catalog.",
  thSessionType: "Session Type",
  thCapacity: "Capacity",
  thQuota: "Sessions",
  thValidityDays: "Validity (days)",
  validityHint: "Leave blank for no expiry (drop-in).",
  planCode: "Plan Code",
  planCodeHint: "Optional unique slug for external deep links (e.g. 4x-personal).",
  oneTimeOnlyLabel: "Once per customer (trial / first-time plan)",
  planIssued: "Issued",

  memberships: "Memberships",
  issueMembership: "Issue Membership",
  issueMembershipTitle: "Issue Membership",
  fulfill: "Fulfill",
  decline: "Decline",
  fulfillRequestTitle: "Fulfill Membership Reservation",
  declineRequestConfirm: "Decline this reservation?",
  deleteRequestConfirm: "Delete this reservation? This cannot be undone.",
  deleteMembershipConfirm: "Delete this membership? This cannot be undone.",
  statusDeclined: "Declined",
  noMembershipsYet: "No memberships issued yet",
  thMember: "Member",
  thPlan: "Plan",
  thRemaining: "Remaining",
  thExpires: "Expires",
  thPurchased: "Purchased",
  thPaid: "Paid",
  selectMember: "Member",
  selectPlan: "Plan",
  paymentMethod: "Payment method",
  amountPaid: "Amount paid",
  amountPaidHint: "Leave blank to use the plan price.",
  partnerName: "Partner",
  partnerNameHint: "Partner's name for pair plans (no account needed).",
  pairWithBadge: "Pair: {name}",
  methodCash: "Cash",
  methodCard: "Card",
  methodLinePay: "LINE Pay",
  methodOther: "Other",
  issue: "Issue",
  adjustMembership: "Adjust",
  adjustMembershipTitle: "Adjust Membership",
  newRemaining: "Remaining sessions",
  oneTimeNoAdjustHint: "Remaining sessions can't be changed for a once-per-customer plan.",
  newExpiry: "Expiry date",
  cancelMembershipAction: "Cancel membership",
  confirmCancelMembership:
    "Cancel this membership? Remaining sessions will no longer be usable.",
  reactivate: "Reactivate",
  statusActiveLabel: "Active",
  statusExhausted: "Exhausted",
  statusExpired: "Expired",
  statusCancelled: "Cancelled",
  rptActiveMembers: "Active members",
  rptOutstanding: "Outstanding sessions",
  rptRevenue: "Revenue",
  rptSessionsUsed: "Sessions used",
  rptPurchases: "Purchases",

  membershipIssued: "Membership issued",
  requestFulfilled: "Reservation fulfilled",
  membershipAdjusted: "Membership updated",
  membershipCancelled: "Membership cancelled",
  membershipReactivated: "Membership reactivated",
  requestDeclined: "Reservation declined",
  requestDeleted: "Reservation deleted",
  membershipDeleted: "Membership deleted",
  planCreated: "Plan added",
  planUpdated: "Plan updated",
  planActivated: "Plan activated",
  planDeactivated: "Plan deactivated",

  // b2
  mailboxDeleted: "Mailbox deleted",

  // b3
  loadFailed: "Couldn't load this.",
  reconnecting: "Reconnecting...",
  mainNavigation: "Main",
  menu: "Menu",
  skipToContent: "Skip to main content",

  // b4
  today: "Today",
  jumpToMonth: "Jump to month",
  // Blog — admin/staff authoring.
  blog: "Blog",
  newPost: "New post",
  editPost: "Edit post",
  postTitle: "Title",
  postBody: "Body",
  postStatus: "Status",
  postDate: "Date",
  postTags: "Tags",
  postTagsHint: "Type a #hashtag, press space to add — shown on the post",
  categoryPlaceholder: "e.g. News",
  blogFilterCategories: "Categories",
  blogFilterTags: "Tags",
  blogFilterAll: "All",
  manageCategories: "Manage categories",
  editCategory: "Edit category",
  addCategory: "Add",
  movePostsTo: "Move its posts to",
  uncategorised: "Uncategorised",
  deleteCategoryConfirm: "Delete the category \"{name}\"? Its {count} post(s) will be affected.",
  viewPost: "View",
  draft: "Draft",
  published: "Published",
  postSaved: "Post saved",
  deletePost: "Delete",
  deletePostConfirm: "Delete this post permanently? This cannot be undone.",
  postDeleted: "Post deleted",
  uploadImageFailed: "Image upload failed",
  noPostsYet: "No posts yet",
  noPostsFound: "No posts match your search.",
  searchBlogPosts: "Search title, author, category or tag...",
  blogPostCount: "{count} post(s)",
  thAuthor: "Author",
  thPublishedAt: "Published",
  thUpdatedAt: "Updated",
  bold: "Bold",
  italic: "Italic",
  bulletList: "Bullet list",
  orderedList: "Numbered list",
  setLink: "Link",
  linkUrl: "Link URL",
  insertImage: "Insert image",
  undo: "Undo",
  redo: "Redo",
  // UI/UX pass, 2026-10-08
  roleSuperAdmin: "Super admin",
  roleAdmin: "Admin",
  roleStaff: "Staff",
  lineOnly: "LINE only",
  showLoginEvents: "Show logins",
  unreadLine: "Unread LINE",
  unreadMail: "Unread email",
  upcomingWeek: "Next 7 days",
  noUpcomingWeek: "No bookings in the next 7 days",
  chooseImage: "Choose image",
  // One admin for a clinic and a gym (teisyovision plan.md phase 13).
  staffPlanLinks: "Assigned Plans",
  staffPlanLinksHint: "Only members holding one of the selected plans will see this trainer when booking.",
  staffPlanLinksNone: "No plans selected — this trainer cannot be booked.",
  staffPlanLinksSaveFailed: "Staff saved, but the plan assignment could not be saved.",
  navGroupClinic: "Clinic",
  navGroupGym: "Gym",
  lineAll: "All",
  lineSwitch: "Business line",
  navGroupAdmin: "Admin",
  thKind: "Line",
  kindAll: "All",
  kindClinic: "Clinic",
  kindGym: "Gym",
  serviceKindHint: "Gym session types are booked only through a membership plan.",
  openingSpecialScope: "Applies to",
  openingSpecialScopeHint: "Choose which services or plans the special price covers.",
  scopeAll: "Everything (clinic and gym)",
  scopeClinic: "All clinic services",
  scopeGym: "All gym sessions and plans",
  scopeService: "Service: {name}",
  scopePlan: "Plan: {name}",
};
export default en;
